// Entry Tracking Utilities - URL parameter reading and localStorage management

import { setStorage } from './storage.js';

/**
 * Get all URL parameters as an object
 * @returns {Object} Object containing all URL parameters
 */
const getURLParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const params = {};
  for (const [key, value] of urlParams) {
    params[key] = value;
  }
  return params;
};

/**
 * Save entry tracking value to localStorage with 30-day expiration
 * @param {string} value - The entry tracking value to save
 */
const setEntryTrackingToStorage = (value) => {
  const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
  setStorage('ENTRY_TRACKING', value, thirtyDaysInMs);
};

/**
 * Main function: Check URL parameters for entrytracking and save to localStorage
 */
const handleEntryTracking = () => {
  const params = getURLParams();
  if (params.entrytracking) {
    setEntryTrackingToStorage(params.entrytracking);
  }
};

/**
 * Auto-initialization function (runs automatically on page load)
 */
const initEntryTracking = () => {
  // Wait for DOM to load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleEntryTracking);
  } else {
    handleEntryTracking();
  }
};

// Auto-run in browser environment
if (typeof window !== 'undefined') {
  initEntryTracking();
}